module.exports = __webpack_public_path__ + "img/logo1.9495d063.png";